var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Lede"},[_c('h1',[_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._t("default")],2),_c('Rule',{attrs:{"thirds":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }